import { useDelayedQuery } from "./delay";
import { isOngoing, useStatuses } from "./status";

export type StreamCenterGame = {
    id: number;
    categoryId: number;
    name: string;
    description: string;
    logoTeam1: string;
    gameName: string;
    popularLive: boolean;
    logoTeam2: string;
    videoUrl: string;
    beginPartie: string;
    endPartie: string;
};

const STREAM_CENTER_AMERICAN_FOOTBALL_CATEGORY_ID = 14;

export type Game = {
    home: string;
    away: string;
    streamUrl: string;
};

export const useStreams = () => {
    const query = useDelayedQuery<Game[]>(
        "streams",
        async (previousGames = []) => {
            const response = await fetch(
                "https://backend.streamcenter.live/api/Parties?pageNumber=1&pageSize=500",
            );
            const data: StreamCenterGame[] = await response.json();

            const games = data
                .filter(
                    (g) =>
                        g.categoryId ===
                            STREAM_CENTER_AMERICAN_FOOTBALL_CATEGORY_ID &&
                        g.name !== "NFL REDZONE",
                )
                .map((g) => {
                    const [away, home] = g.name.split(" vs ");
                    const streamUrl = g.videoUrl.split("<")[0]; // Split the <English from the end
                    return {
                        streamUrl,
                        home,
                        away,
                    };
                });

            for (const previousGame of previousGames) {
                if (
                    !games.find((g) => g.streamUrl === previousGame.streamUrl)
                ) {
                    games.push(previousGame);
                }
            }

            return games;
        },
        {
            revalidateOnFocus: false,
        },
    );

    return query;
};

export const useStreamingGames = () => {
    const { data: statuses } = useStatuses();
    const { data: streams } = useStreams();

    if (!statuses || !streams) {
        return [];
    }

    return statuses.filter(isOngoing).flatMap((status) => {
        const stream = streams?.find(
            (stream) =>
                stream.home === status.home && stream.away === status.away,
        );
        if (!stream && status.status === "FINISHED") {
            return [];
        }
        return [
            {
                game: stream,
                status,
            },
        ];
    });
};
